export const flattenErrors = (errors, touched) => {
    let messages = [];
    Object.entries(errors || {}).forEach(([key, val]) => {
        const touchedVal = touched ? touched[key] : undefined;
        if (typeof val === 'string') {
            if (touchedVal) messages.push(val);
        } else if (typeof val === 'object' && val !== null) {
            if (typeof touchedVal === 'object' && touchedVal !== null) {
                messages = messages.concat(flattenErrors(val, touchedVal));
            }
        }
    });
    return messages;
};